// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1iAQz","content":"GlobalSearch_content__2-jax"};